module.exports = __webpack_public_path__ + "img/group-131.ef51dbab.png";